import validate from "/tmp/build_db7b5d36/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/tmp/build_db7b5d36/middleware/auth.global.ts";
import manifest_45route_45rule from "/tmp/build_db7b5d36/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "backstage-auth": () => import("/tmp/build_db7b5d36/middleware/backstageAuth.ts"),
  "backstage-is-user": () => import("/tmp/build_db7b5d36/middleware/backstageIsUser.ts"),
  "is-admin": () => import("/tmp/build_db7b5d36/middleware/isAdmin.ts"),
  "is-not-user": () => import("/tmp/build_db7b5d36/middleware/isNotUser.ts"),
  "is-user": () => import("/tmp/build_db7b5d36/middleware/isUser.ts")
}